module.exports = "img/hugo.5c84ba.png";